import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import './index.scss';

const ModalName = 'ModalPrize';
const Names = {
    exchange_token : "Exchange Token",
    spin_token  : "Spin Token"
}

const Prize = ({ name, toggleModal }) => {
	const closeModal = () => toggleModal(ModalName);
	const { item, localize } = useSelector(
		(state) => ({ item: state.main.prize, localize: state.localize.event }),
		shallowEqual
	);
    
	return (
		<Modal
			open={name[ModalName]}
			classNames={{
				modal: `modal modal-prize`,
				overlay: 'overlay',
				closeButton: 'close-button',
				closeIcon: 'close-icon',
				modalAnimationIn: 'slideInUp',
				modalAnimationOut: 'slideOutDown',
			}}
			animationDuration={250}
			center
			focusTrapped={false}
			showCloseIcon={false}
			closeOnOverlayClick={false}
			onClose={closeModal}
			blockScroll={false}
		>
			<div className="modal-title">
				<h3>{localize?.txt_congrats_title}</h3>
			</div>
			<div className="modal-content">
				<p className="text">
					{localize?.txt_you_got}
					<b style={{ margin: '0 .05rem' }}>{Names[item?.item_name] ?? item?.item_name}</b>!
				</p>
				<div className="item">
					<div className={`item-img item-img-${item?.id}`}>
						<img alt="" src={item?.item_image} />
						<span className="item-count">x{item?.quantity || item?.item_count}</span>
					</div>
				</div>
				<div className="group">
					<button
						onClick={closeModal}
						className="btn btn-ok"
						type="button"
						aria-label="Ok"
					>
						{localize?.txt_ok}
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default Prize;
